import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react'
import GetSearchResult from '../Utility/GetSearchResult/GetSearchResult'
import searchContext from './../FiltersComponent/context/context'
import './MapComponent.css'
import MapInfoWindow from './MapInfoWindow/MapInfoWindow'
import { renderToString } from 'react-dom/server'
import subjectIcon from '../Assets/star.png'
import { isFilterApplied, getPropertyTypeIcon } from '../Utility/Utility.js'

let drawingManager
let overlays

const MapComponent = props => {
  const { fullHeight, propertyList, showCluster, isList } = props

  const { searchCriteria, infoWindowToShow, setInfoWindowToShow, setSearchResult,
    setSearchCriteria, setShowSpinner, searchFields, setSearchFields,
    setPreSearchCriteria, preSearchCriteria } = useContext(searchContext)

  const [zoom, setZoom] = useState(3)
  const [center, setCenter] = useState({ lat: 41.039556, lng: -96.436097 })
  const [isSubjectExists, setIsSubjectExists] = useState(false)
  const [isShowCluster, setIsShowCluster] = useState(true)
  const [map, setMap] = useState()
  const [maps, setMaps] = useState()
  const [markerCluster, setMarkerCluster] = useState()
  const [markers, setMarkers] = useState([])
  const [polygonPaths, setPolygonPaths] = useState([])

  useEffect(() => {

    initializeMap()

  }, [propertyList, maps])

  useEffect(() => {

    if (!isList && maps) {
      initDrawing(map, maps)
    }

  }, [maps])

  useEffect(() => {

    if (searchCriteria.polygon.points.length === 0) {
      clearMap()
    }

  }, [searchCriteria.polygon.points.length])

  useEffect(() => {
    toggleClusterView()

  }, [isShowCluster])

  useEffect(() => {

    if (markerCluster && infoWindowToShow) {
      highlightProperty()
    }

  }, [infoWindowToShow])

  useEffect(() => {
    searchByPolygon()
  }, [polygonPaths])

  useEffect(() => {
    if (!isList && map && maps && !overlays && searchCriteria.polygon.points.length > 0) {
      drawPolygon()
    }
  }, [searchCriteria, map, maps])

  const initializeMap = () => {
    if (isList) {
      let index = propertyList.findIndex(x => x.isSubjectProperty)
      if (index !== -1) {
        setIsSubjectExists(true)
      }
    } else {
      setIsSubjectExists(searchCriteria.subjectProperty.omniViewPropertyId ? true : false)
    }

    clearPropertyMarkers()
    if (propertyList.length > 0) {
      displayPropertyMarker()
    }
    else {
      setMapDefaults()
    }
  }

  const drawPolygon = () => {
    // console.log('drawPolygon')
    var arrayPolygon = [];
    for (var i = 0; i < searchCriteria.polygon.points.length; i++) {
      let coordsArr = {};
      let lat = parseFloat(searchCriteria.polygon.points[i].split(',')[0])
      let lng = parseFloat(searchCriteria.polygon.points[i].split(',')[1])

      coordsArr['lat'] = lat
      coordsArr['lng'] = lng
      arrayPolygon.push(coordsArr)
    }
    // console.log('arrayPolygon = ', arrayPolygon)

    overlays = new maps.Polygon({
      paths: arrayPolygon,
      strokeColor: '#FF0000',
      fillColor: '#21610B',
      fillOpacity: 0.15,
      strokeWeight: 2,
      clickable: true,
      draggable: false,
      strokeOpacity: 0.8,
      zIndex: 1,
      myPolygonType: 'poly'
    });
    // console.log('map = ', map)
    overlays.setMap(map);

  }

  const highlightProperty = () => {

    if (activeWindow) {
      activeWindow.close()
    }

    let index = markerCluster.markers_.findIndex(x => x.label.id === infoWindowToShow)

    setInfoWindowToShow('')

    if (index !== -1) {
      maps.event.trigger(markerCluster.markers_[index], 'click')
      map.setZoom(16);
      map.panTo(markerCluster.markers_[index].position)
    }
  }

  const getIcon = type => {
    let returnVal
    let scaledSize = new google.maps.Size(35, 35)
    if (type === 'subject') {
      returnVal = subjectIcon
    }
    else {
      getPropertyTypeIcon
      returnVal = {
        url: getPropertyTypeIcon(type),
        scaledSize
      }
    }
    // if (type === 'default') {
    //   let canvas = document.createElement("canvas")
    //   let ctx = canvas.getContext("2d")
    //   canvas.width = 25
    //   canvas.height = 25

    //   ctx.beginPath()
    //   ctx.arc(240, 160, 20, 0, Math.PI * 2, false)
    //   ctx.fillStyle = "green"
    //   ctx.fill()
    //   ctx.closePath()

    //   returnVal = canvas.toDataURL('image/jpeg')
    // }

    return returnVal
  }

  const getSubjectProperty = () => {
    let property = {}
    const i = propertyList.findIndex(x => x.omniViewPropertyId === searchCriteria.subjectProperty.omniViewPropertyId)
    if (i !== -1) {
      property = propertyList[i]
    }

    return property
  }

  const displayPropertyMarker = () => {

    if (maps && map) {
      // console.log('maps.Marker:::', maps.Marker)
      setIsShowCluster(true)

      let fitBoundmarkers = []
      let newMarkers = []

      for (let i = 0; i < propertyList.length; i++) {
        const property = propertyList[i]
        if (property.propertyLocation) {
          const propertyLocation = property.propertyLocation.split(',')
          const _lat = parseFloat(propertyLocation[0], 10)
          const _lng = parseFloat(propertyLocation[1], 10)

          let makerText = i
          let propertyIndex = 1
          if (isList && isSubjectExists) {
            propertyIndex = (propertyList.filter(x => x.isSubjectProperty).length)
          }

          makerText = isSubjectExists ? makerText : makerText + 1

          // this will fix incoorrect marker text when multiple subject property
          makerText = propertyIndex > 1 ? makerText - propertyIndex + 1 : makerText
          makerText = makerText === 0 ? 'S' : makerText

          let isSubject = false
          if (isList) {
            isSubject = property.isSubjectProperty
          } else {
            let subjectProperty = getSubjectProperty()
            isSubject = subjectProperty.omniViewPropertyId === property.omniViewPropertyId ? true : false
          }

          if (propertyLocation.length === 2) {
            fitBoundmarkers.push({ lat: _lat, lng: _lng })
            newMarkers.push({
              text: makerText,
              position: { lat: _lat, lng: _lng },
              property: property,
              isSubject: isSubjectExists && isSubject
            })
          }
        }
      }

      let newBounds = new maps.LatLngBounds()

      for (var i = 0; i < fitBoundmarkers.length; i++) {
        newBounds.extend(fitBoundmarkers[i])
      }

      map.fitBounds(newBounds)

      newMarkers = newMarkers && newMarkers.map((location) => {
        return addSingleMarker(location)
      })

      setMarkers(newMarkers)

      let minimumClusterSize = 4
      if (isList) {
        minimumClusterSize = propertyList.length + 1
      }

      let newMarkerCluster = new MarkerClusterer(map, newMarkers, {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
        gridSize: 30,
        minimumClusterSize: minimumClusterSize,
      })

      setMarkerCluster(newMarkerCluster)
      // setIsShowCluster(isShowCluster)

    }

  }

  let activeWindow
  const addSingleMarker = location => {
    // console.log('location = ', location.property.omniViewPropertyType)
    let propMarker = new maps.Marker({
      label: {
        text: location.text.toString(),
        color: "White",
        id: location.property.omniViewPropertyId,
        fontSize: "11px"
      },
      // animation: maps.Animation.DROP,
      draggable: isList ? true : false,
      position: location.position,
      optimized: true
      // labelClass: "circle_marker"
    })

    if (location.isSubject) {
      propMarker.setIcon(getIcon('subject'))
      propMarker.label = {
        text: 's',
        id: location.property.omniViewPropertyId
      }
    } else {
      propMarker.setIcon(getIcon(location.property.omniViewPropertyType))
    }

    maps.event.addListener(propMarker, 'click', function (evt) {
      let infoWin = new maps.InfoWindow()

      if (activeWindow) {
        activeWindow.close()
      }

      let infoContent = <MapInfoWindow property={location.property}></MapInfoWindow>
      infoContent = renderToString(infoContent)
      infoWin.setContent(infoContent)
      infoWin.open(map, propMarker)

      activeWindow = infoWin
    })

    return propMarker
  }

  const clearPropertyMarkers = () => {

    if (markers.length) {
      markerCluster.setMap(null)
      for (var i = 0; i < markerCluster.markers_.length; i++) {
        markerCluster.markers_[i].setMap(null)
      }
    }

    setMarkers([])
    setMarkerCluster(null)
  }

  const setMapDefaults = () => {
    setCenter({ lat: 41.039556, lng: -96.436097 })
    setZoom(3)

  }

  const initDrawing = () => {
    // console.log('initDrawing')
    drawingManager = new maps.drawing.DrawingManager({ //this allows you to add polygon on map
      drawingMode: null, //google.maps.drawing.OverlayType,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        //drawingModes: [ 'circle', 'polygon', 'polyline', 'rectangle']
        drawingModes: ['polygon']
      },
      polygonOptions: {
        strokeColor: '#FF0000',
        fillColor: '#21610B',
        fillOpacity: 0.15,
        strokeWeight: 2,
        clickable: true,
        draggable: true,
        strokeOpacity: 0.8,
        zIndex: 1,
        myPolygonType: 'poly'
      },

      polylineOptions: {
        strokeColor: '#FF0000',
        strokeWeight: 2,
        clickable: true,

        draggable: true,
        strokeOpacity: 0.8,
        zIndex: 1,
        myPolygonType: 'polyLine'
      },

    });

    drawingManager.setMap(map);

    maps.event.addListener(drawingManager, 'polygoncomplete', function (event) {

      // removing previous drawing. 
      clearMap()

      updatePolygon(event)

      maps.event.addListener(event, 'dragend', function () {
        updatePolygon(event, true)
      });

    });


  }

  const clearMap = () => {
    // debugger
    // console.log('overlays = ', overlays)
    if (overlays) {
      // debugger
      overlays.setMap(null);
    }
  }

  const updatePolygon = (event) => {
    // console.log('updatePolygon')
    // setOverlays(event)
    overlays = event
    // debugger
    var polygon = event.getPath().getArray();
    let newpolygonPaths = []
    for (var i = 0; i < polygon.length; i++) {
      newpolygonPaths.push(event.getPath().getAt(i).toUrlValue(6))
    }

    drawingManager.setOptions({
      drawingMode: null
    });

    if (newpolygonPaths.length < 3) {
      if (overlays) {
        overlays.setMap(null);
      }
      setPolygonPaths([])
      return
    }

    setPolygonPaths(newpolygonPaths)

  }

  const searchByPolygon = async () => {

    let newSearchCriteria = searchCriteria
    let newSearchFields = searchFields
    // console.log('polygonPaths = ', polygonPaths)
    try {
      if (polygonPaths && polygonPaths.length > 0) {
        setShowSpinner(true)

        newSearchFields.SubjectProperty = []
        setSearchFields(newSearchFields)

        newSearchCriteria.polygon = { 'points': polygonPaths }
        newSearchCriteria.property = { 'propertyName': '', 'priorName': false }
        newSearchCriteria.subjectProperty = {}
        newSearchCriteria.distanceFields = []
        newSearchCriteria.prospecting = []

        const searchResult = new GetSearchResult(newSearchCriteria, function () { })
        const response = await searchResult.fetchSearchResult()
        setShowSpinner(false)
        if (response.data && response.data.data) {
          let data = response.data.data
          setSearchResult({ property: data, totalCount: response.data.total })
        }
        setPreSearchCriteria({ ...preSearchCriteria, searchType: 'prospecting' })
      }
      // else {
      //   newSearchCriteria.polygon = { 'points': [] }
      // }
    } catch (error) {
      console.log('error polygon= ', error)

    }

    setSearchCriteria(newSearchCriteria)
  }

  const apiLoaded = (map, maps) => {
    setMap(map)
    setMaps(maps)
  }

  const toggleClusterView = () => {
    if (markerCluster) {
      if (isShowCluster) {
        markerCluster.setMap(map)
      } else {
        markerCluster.setMap(null)
      }
    }
  }

  const defaultMapOptions = () => {
    if (maps) {
      return {
        fullscreenControl: fullHeight,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        // scaleControl: true,
        // scrollwheel: false,
        // zoomControl: isScreenShot ? false : true,
      }
    } else {
      return { fullscreenControl: fullHeight }
    }
  }

  async function clearPolygonCriteria() {

    let newSearchCriteria = searchCriteria
    newSearchCriteria.polygon = { 'points': [] }
    setSearchCriteria(newSearchCriteria)

    if (!isFilterApplied(newSearchCriteria)) {
      setSearchResult({ property: [], totalCount: 0 })
      return
    }

    setShowSpinner(true)

    const searchResult = new GetSearchResult(newSearchCriteria, function () { })
    const response = await searchResult.fetchSearchResult()
    setShowSpinner(false)
    if (response.data && response.data.data) {
      let data = response.data.data
      setSearchResult({ property: data, totalCount: response.data.total })
    }

  }

  return (
    <>
      <div className={`w-full h-full max-w-sm rounded overflow-hidden shadow-lg ${fullHeight ? 'shadow-5' : 'shadow-1'}`} >
        <GoogleMapReact
          yesIWantToUseGoogleMapApiInternals
          bootstrapURLKeys={{
            // key: process.env.REACT_APP_GOOGLE_API_KEY,
            // key: envConfig[currentENV()].REACT_APP_GOOGLE_API_KEY,
            key: window.REACT_GLOBAL_CONFIG.REACT_APP_GOOGLE_API_KEY,
            version: '3.64',
            libraries: ['places', 'drawing']
          }}
          // defaultCenter={propertyList.length > 0 ? center : defaultCenter}
          defaultCenter={center}
          // center={center}
          defaultZoom={zoom}
          zoom={zoom}
          // onReady={({ mapProps, maps }) => initMap(mapProps, maps)}
          onGoogleApiLoaded={({ map, maps }) => apiLoaded(map, maps)}
          options={defaultMapOptions()}
        // bounds={bounds}
        >
          {/* this is working code to display markers */}
          {/* {propertyList.map((property, index) => {
            const propertyLocation = property.propertyLocation.split(',')
            const lat = parseFloat(propertyLocation[0], 10)
            const lng = parseFloat(propertyLocation[1], 10)
            if (propertyLocation.length != 2) {
              return
            }

            let makerText = index
            makerText = isSubjectExists ? makerText : makerText + 1
            makerText = makerText === 0 ? 'S' : makerText

            return (
              <PropertyMarker lat={lat} lng={lng} text={makerText}></PropertyMarker>
            )
          })} */}
        </GoogleMapReact>
      </div>
      <div className="flex justify-between">
        {
          (propertyList.length > 0 && fullHeight && showCluster) ?
            <div >
              <span className="pr-4">
                <input data-testid="test-chk-show-cluster" checked={isShowCluster} onChange={() => setIsShowCluster(!isShowCluster)} type="checkbox" />
              </span>
              <span data-testid="" className="cursor-pointer" onClick={() => setIsShowCluster(!isShowCluster)}>
                Show Cluster
              </span>
            </div>
            : <div></div>
        }
        {fullHeight && !isList &&
          <div >
            <button onClick={() => { clearPolygonCriteria() }}>Clear</button>
          </div>
        }
      </div>
    </>
  )
}

export default MapComponent

MapComponent.propTypes = {
  fullHeight: PropTypes.bool.isRequired,
  isList: PropTypes.bool
}
